import StoreLocatorPage from '../containers/StoreLocator'

export default StoreLocatorPage